import React from "react";
import { Row, Col, Input, Button, Drawer } from "antd";
import { Scrollbars } from "react-custom-scrollbars";
import Close from "../../../../assets/images/close-x.svg";
import SearchIcon from "../../../../assets/images/searchIcon.svg";

const SelectBagDrawer = ({
  addToBagFlag,
  setAddToBagFlag,
  searchTerm,
  setSearchTerm,
  filtredBags,
  pickProduct,
  selectBagRef,
  filteredGiftCards,
  selectGiftCard,
  setKeyboardType,
  setOpen,
  setLayoutName,
}) => {
  return (
    <Drawer
      closable={true}
      placement="bottom"
      title={
        <div
          style={{
            display: "flex",
            alignItems: "center",
            height: "2.5vh",
            marginTop: "2vh",
            fontSize: "1vw",
          }}
        >
          <Input
            type="text"
            className="productSearch"
            ref={selectBagRef}
            placeholder="Search for Bag"
            // id="giftCardSearchInput"
            id="sm-product-search"
            onPressEnter={() => (filteredGiftCards.length === 1 ? selectGiftCard(filteredGiftCards[0]) : null)}
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            onFocus={() => {
              setKeyboardType({
                searchCus: false,
                parkedBill: false,
                salesHistory: false,
                salesHistoryCus: false,
                product: false,
                giftCardSearch: true,
                salesRep: false,
                addCustomer: false,
              });
              setOpen(true);
            }}
            style={{
              width: "250px",
              marginLeft: "1.8vw",
              padding: "5px",
              borderRadius: "5px",
              border: "1px solid #ccc",
              fontSize: "1vw",
              color: "#0F0718",
              borderColor: "rgba(0, 0, 0, 0.25)",
            }}
            prefix={
              <img
                src={SearchIcon}
                alt=""
                style={{
                  width: "15px",
                  height: "15px",
                  paddingLeft: "0.2vw",
                }}
              />
            }
          />
          <p
            style={{
              fontSize: "1.5em",
              marginTop: "3vh",
              fontWeight: "500",
              color: "#0F0718",
              flex: 1,
              textAlign: "center",
              marginRight: "320px",
            }}
          >
            Select Bag
          </p>
          <img
            src={Close}
            onClick={() => {
              setAddToBagFlag(false);
              setOpen(false);
              setLayoutName("default");
              setSearchTerm("");
            }}
            style={{
              marginLeft: "auto",
              paddingBottom: "4vh",
              paddingTop: "2vh",
              cursor: "pointer",
              width: "1.5vw",
            }}
          />
        </div>
      }
      open={addToBagFlag}
      className="filter"
      closeIcon={null}
      styles={{ body: { paddingBottom: 0, paddingTop: 0 } }}
      // onClose={()=>setAddCashFlag(false)}
      //  id="sm-drawer-close"
      height="85vh"
      onClose={() => {
        setAddToBagFlag(false);
        setOpen(false);
        setLayoutName("default");
        setSearchTerm("");
      }}
    >
      <Scrollbars className="productScroll1">
        <Row
          style={{
            marginTop: "4vh",
            marginLeft: "-0.1vw",
            borderRadius: "10px",
            padding: "0 1vw",
            fontSize: "1vw",
          }}
        >
          {filtredBags?.map((obj, i) => (
            <Col
              push={1}
              span={7}
              pull={1}
              key={i}
              style={{
                backgroundColor: "#fff",
                padding: "2vh 2vw",
                borderRadius: "5px",
                marginRight: "1.5vw",
                marginBottom: "1.5vh",
              }}
            >
              <p style={{ marginBottom: "1.5vh" }} className="productName">
                {/* {obj["name"]} */}
                <span
                  style={{
                    fontWeight: 500,
                    fontSize: "1.25em",
                    color: "#0F0718",
                  }}
                >
                  {obj["name"]}
                </span>
                <span
                  style={{
                    display: "block",
                    fontSize: "1em",
                    fontWeight: 400,
                    color: "#0F0718",
                  }}
                >
                  Code: {obj["value"]}
                </span>
              </p>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  fontSize: "1vw",
                }}
              >
                <span></span>
                <Button
                  onClick={() => {
                    pickProduct(obj);
                    setAddToBagFlag(false);
                  }}
                  style={{
                    fontSize: "1em",
                    color: "#fff",
                    backgroundColor: "#2F3856",
                    padding: "0.3vh 2.3vw",
                    borderRadius: "3px",
                    cursor: "pointer",
                    fontWeight: 500,
                  }}
                >
                  ADD
                </Button>
              </div>
            </Col>
          ))}
        </Row>
      </Scrollbars>
    </Drawer>
  );
};

export default SelectBagDrawer;
